import { Box } from '@mui/material';
import { useFormikContext } from 'formik';
import { ContentCard } from 'components/Card';
import { getTrans } from 'modules/i18n';
import { CVBuilderFormValues } from 'utils/cv-form-db';
import { EditModeNavigationButtons } from '../../components/EditModeNavigationButtons';
import { PreviousStepNavigationButton } from '../../components/PreviousStepNavigationButton';
import { StepNavigationButton } from '../../components/StepNavigationButton';
import { RootBox } from '../../components/styledComponents';
import { useEditModeNavigation } from '../../hooks/useEditModeNavigation';
import { CertificatesForm } from './CertificatesForm';

export const CertificatesStep = () => {
  const { values, setFieldValue } = useFormikContext<CVBuilderFormValues>();
  const { isEditMode } = useEditModeNavigation();

  const handleRemoveCertificate = async (certificateToRemove: string) => {
    const newCertificates =
      values.certificates?.filter(
        certificate => certificate !== certificateToRemove
      ) || [];
    await setFieldValue('certificates', newCertificates);
  };

  const handleCertificateChange = async (newCertificates: string[]) => {
    await setFieldValue('certificates', newCertificates);
  };

  // The step progress indicator moved into the shared StepHeader (rendered by
  // StepContentSwitch), so it no longer needs repeating inside every step card.
  return (
    <RootBox
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'column'
      }}
    >
      <ContentCard
        title={getTrans('cvBuilderPage.overview.certificates.title')}
        titleVariant="h4"
      >
        <CertificatesForm
          handleCertificateChange={handleCertificateChange}
          handleRemoveCertificate={handleRemoveCertificate}
        />
      </ContentCard>

      <Box sx={{ flex: 1 }} />

      {isEditMode ? (
        <EditModeNavigationButtons />
      ) : (
        <>
          <StepNavigationButton step="CERTIFICATES" />
          <PreviousStepNavigationButton step="CERTIFICATES" />
        </>
      )}
    </RootBox>
  );
};
